// Org policy writes go through the backend (api/policyApi.js) so every change
// becomes a numbered revision + audit row that Administration → Policy
// history can show and restore. The rules refuse direct client edits of the
// six policy maps on the org doc — use these, never updateEntity('org', …).
import { useMemo } from 'react';
import { apiPost, apiPut } from '../utils/backendApi';
import { useEntityList } from './entities';

export const POLICY_LABELS = {
  guardrails: 'Guardrails',
  reviewRouting: 'Review routing',
  envControls: 'Environment controls',
  pipelinePolicy: 'Workflow requirements',
  permissions: 'Permissions',
  costLimits: 'Cost limits',
  models: 'Model ladder',
};

export const POLICY_AREAS = Object.keys(POLICY_LABELS);

// Where each area is edited (relative to /orgs/:id/).
export const POLICY_EDIT_ROUTE = {
  guardrails: 'knowledge?tab=guardrails',
  reviewRouting: 'human-review?tab=routing',
  envControls: 'administration?tab=environments',
  pipelinePolicy: 'administration?tab=environments',
  permissions: 'administration?tab=permissions',
  costLimits: 'settings',
  models: 'administration?tab=models',
};

export const savePolicy = (orgId, area, value, reason = '') => apiPut(`/orgs/${orgId}/policy/${area}`, { value, reason });
export const restorePolicyRevision = (orgId, revisionId) => apiPost(`/orgs/${orgId}/policy/revisions/${revisionId}/restore`, {});
export const decideBudgetRequest = (orgId, requestId, body) => apiPost(`/orgs/${orgId}/budget-requests/${requestId}/decide`, body);

// Live list of revisions (admin read — pass enabled=false for other seats so
// no refused query is issued), newest first, optionally one area.
export function usePolicyRevisions(orgId, area = null, { enabled = true } = {}) {
  const { docs, error } = useEntityList('policyRevision', { org: orgId }, { orderBy: 'createdAt', dir: 'desc', enabled });
  const revisions = useMemo(() => {
    const all = docs || [];
    return area ? all.filter((r) => r.area === area) : all;
  }, [docs, area]);
  return { revisions, loading: docs === null, error };
}
